import React from 'react';

import styles from './styles.module.scss';

export const AppLoader: React.FC = () => {
    return (
        <div className={styles.loader}>
            <div className={`${styles.element} ${styles.top}`} />
            <div className={`${styles.element} ${styles.bottom}`}  />
            <div className={`${styles.element} ${styles.left}`}  />
            <div className={`${styles.element} ${styles.moved}`}  />
        </div>
    )
};